var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2634_93819",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2634_93819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.85 10.6L13.4 9.15L16.6 6H15C14.7167 6 14.4793 5.90433 14.288 5.713C14.096 5.521 14 5.28333 14 5C14 4.71667 14.096 4.479 14.288 4.287C14.4793 4.09567 14.7167 4 15 4H19C19.2833 4 19.5207 4.09567 19.712 4.287C19.904 4.479 20 4.71667 20 5V9C20 9.28333 19.904 9.52067 19.712 9.712C19.5207 9.904 19.2833 10 19 10C18.7167 10 18.4793 9.904 18.288 9.712C18.096 9.52067 18 9.28333 18 9V7.4L14.85 10.6ZM12 20C11.7167 20 11.4793 19.904 11.288 19.712C11.096 19.5207 11 19.2833 11 19V12.4L6 7.4V9C6 9.28333 5.90433 9.52067 5.713 9.712C5.521 9.904 5.28333 10 5 10C4.71667 10 4.479 9.904 4.287 9.712C4.09567 9.52067 4 9.28333 4 9V5C4 4.71667 4.09567 4.479 4.287 4.287C4.479 4.09567 4.71667 4 5 4H9C9.28333 4 9.521 4.09567 9.713 4.287C9.90433 4.479 10 4.71667 10 5C10 5.28333 9.90433 5.521 9.713 5.713C9.521 5.90433 9.28333 6 9 6H7.4L13 11.6V19C13 19.2833 12.9043 19.5207 12.713 19.712C12.521 19.904 12.2833 20 12 20Z",
    fill: "#1F242F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.62d20e7199561fdbcaee851cfc6cff58.svg";
export { ForwardRef as ReactComponent };